/** Reset server CSV “exclude cross-source” when modal opens or column is removed. */
import { useEffect, useState } from 'react';

export function useCsvExportModalCrossSourceExclude(
  open: boolean,
  exportColumnKeys: string[],
): readonly [boolean, (v: boolean) => void] {
  const [excludeCrossSourceNotedRows, setExcludeCrossSourceNotedRows] =
    useState(false);
  useEffect(() => {
    if (open) setExcludeCrossSourceNotedRows(false);
  }, [open]);
  useEffect(() => {
    if (!exportColumnKeys.includes('crossSourceFilterNote')) {
      setExcludeCrossSourceNotedRows(false);
    }
  }, [exportColumnKeys]);
  return [excludeCrossSourceNotedRows, setExcludeCrossSourceNotedRows] as const;
}
